import i18n from "../i18n";

// Helper to prepend current language to a path
export function getLocalizedPath(path: string) {
  const lang = i18n.language;
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `/${lang}/${cleanPath}`;
}